module.exports = "<p>Logout redirection...</p>\n"